define('lib/web-assets/javascripts/features/login/views',[], function() {
    return {
        defaultView: Backbone.View.extend({
            el: 'body',
            events: {
                'click .faq-link': 'showFaq',
                'click .show-video': 'showVideo'
            },
            render: function() {
                KMD.Helpers.setTimeZone();
                $('#username').focus();

                if(KMD.Cookies.get("username")){
                    $('#username').val(KMD.Cookies.get("username").replace(/["]/g, ""));
                    $('#rememberUsername').prop('checked', true);
                    $('#password').focus();
                }

                if ($.browser.msie){
                    if (parseInt($.browser.version, 10) < 9){
                        $('#iewarning').html(KMD.Helpers.renderTemplate('ieWarningTemplate')).show();
                    }
                }
            },
            showFaq: function() {
                KMD.Views.getView('faqModalView').render();
            },
            showVideo: function() {
                videojs.options.flash.swf = window.swfLocation;
                player = videojs('accoladeVideo');
                $('#videoModal').modal('show');
                $('#videoModal').on('hidden', function(){
                    player.pause();
                });
                player.ready(function() {
                    player.play();
                });
            }
        }),
        faqModalView: Backbone.View.extend({
            el: '#modalContainer',
            render: function() {
                this.$el.html(KMD.Helpers.renderTemplate('faqModalTemplate')).modal('show');
                KMD.Helpers.formatPhone();
            }
        })
    };
});
